import { NgClass } from '@angular/common';
import { AfterViewInit, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LazyLoadEvent, PrimeTemplate } from 'primeng/api';
import { Button } from 'primeng/button';
import { Card } from 'primeng/card';
import { Dialog } from 'primeng/dialog';
import { SelectButton } from 'primeng/selectbutton';
import { Tooltip } from 'primeng/tooltip';
import { ServiceResult } from '../../../../core/interfaces/service-result';
import { SpsTableComponent } from '../../../../custom/components/sps-table/sps-table.component';
import { SpsTransactionDetailsDialogComponent } from '../../../../custom/components/sps-transaction-details-dialog/sps-transaction-details-dialog.component';
import { BaseTransactionViewComponent } from '../../base/base-transaction-view.component';

@Component({
  selector: 'app-admin-transactions-view',
  imports: [
    Button,
    Card,
    Dialog,
    PrimeTemplate,
    SelectButton,
    SpsTableComponent,
    SpsTransactionDetailsDialogComponent,
    FormsModule,
    NgClass,
    Tooltip
  ],
  templateUrl: './admin-transactions-view.component.html',
})
export class AdminTransactionsViewComponent extends BaseTransactionViewComponent implements OnInit, AfterViewInit, OnDestroy{

  protected tableConfigKeyName = 'SPS_ADMIN_TRANSACTIONS_VIEW';
  protected tableRowsKeyName = 'ADMIN_TRANSACTIONS_VIEW_ROWS';
  protected tableStateKeyName = 'ADMIN_TRANSACTIONS_VIEW_STATE';
  public transactionViewMode: 'TENANT' | 'ADMIN' = 'ADMIN';


  private route = inject(ActivatedRoute);
  private router = inject(Router);

  /**
   * tenantId from the organisation
   * @private
   */
  private tenantId: string;

  override async ngOnInit() {
    await super.ngOnInit();
    this.route.paramMap.subscribe(params => {
      if (params && (params.get('tenantId') !== null)) {
        this.tenantId = params.get('tenantId');
      } else {
        this.router.navigate(['/error/auth']);
      }
    });

  }

  override ngAfterViewInit(): void {

    super.ngAfterViewInit();

    /**
     * Initialize Breadcrumb-Items
     */
    setTimeout(() => {
      this.i18n.breadcrumbMenuItems.set([
        {
          icon: 'pi pi-cog',
          i18nLabelKey: 'MENUCUSTOMERS',
          label: this.i18n.i18nLng()['MENUCUSTOMERS'],
          routerLink: ['/admincustomers'],
          routerLinkActive: false
        },
        {
          i18nLabelKey: 'MENUTRANSACTIONS',
          label: this.i18n.i18nLng()['MENUTRANSACTIONS'],
          routerLinkActive: true
        }
      ]);
    }, 50);

  }

  override ngOnDestroy() {
    super.ngOnDestroy();
  }

  /**
   * Parent-Data-Provider
   * @param lazyLoadEvent
   */
  getTransactionPageData = (lazyLoadEvent: LazyLoadEvent) => {
    this.lastLazyLoadingEvent = lazyLoadEvent;
    return this.transactionDataService.findTenantPage(lazyLoadEvent, this.tenantId, this.currentState);
  }

  /**
   * DataMapper for table-data
   * @param serviceResult
   */
  transactionDataMapper = (serviceResult: ServiceResult) => {
    try {
      serviceResult.payload.map(transactionData => {
        return this.transactionDataMapperService.map(transactionData);
      });
      return serviceResult;
    } catch (e) {
      return null;
    }
  }

  /**
   * Export current transaction data as csv file
   * @protected
   */
  protected exportTransactionData() {
    /**
     * TODO implement when route is known and if feature should be implemented
     * TODO Export ist currently not wanted in the administration mode!!!
     */
    /*
    const exportUrl: string = this.transactionDataService.baseUrl + '/transactiondata/export?search=' + encodeURIComponent(JSON.stringify(this.lastLazyLoadingEvent)) + '&status=' + this.currentState;
    const subscription: Subscription = this.fileService.downloadFile(exportUrl).subscribe({
      next: success => {
        subscription.unsubscribe();
        if (success) {
          this.messageService.add({
            life: 3500,
            severity: 'success',
            summary: this.i18n.i18nLng()['FILEDOWNLOADTITLE'],
            detail: this.i18n.i18nLng()['FILEDOWNLOADSUCCESS']
          });
        } else {
          this.messageService.add({
            sticky: true,
            severity: 'error',
            summary: this.fileService?.errorHandler?.message,
            detail: this.fileService?.errorHandler?.details + '\n' + this.i18n.i18nLng()['CONTACTSUPPORT']
          });
        }
      }
    });
     */
  }


}
